var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.11111C4 2.49746 4.51167 2 5.14286 2H18.8571C19.4883 2 20 2.49746 20 3.11111C20 3.72476 19.4883 4.22222 18.8571 4.22222H14.1811C15.122 5.22891 15.7693 6.51087 15.9942 7.92593H18.8571C19.4883 7.92593 20 8.42339 20 9.03704C20 9.65069 19.4883 10.1481 18.8571 10.1481H15.9942C15.5862 12.7158 13.7872 14.8453 11.367 15.6871L15.7615 20.1176C16.1996 20.5594 16.1864 21.2628 15.7321 21.6887C15.2777 22.1147 14.5542 22.1019 14.1161 21.6601L8.23855 15.7342C7.92031 15.4134 7.83009 14.9387 8.00938 14.5284C8.18867 14.1182 8.60276 13.8519 9.06122 13.8519C11.271 13.8519 13.1736 12.2939 13.67 10.1481H5.14286C4.51167 10.1481 4 9.65069 4 9.03704C4 8.42339 4.51167 7.92593 5.14286 7.92593H13.67C13.1736 5.78015 11.271 4.22222 9.06122 4.22222H5.14286C4.51167 4.22222 4 3.72476 4 3.11111Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.393722705edd13e6eaecf18baf4e0835.svg";
export { ForwardRef as ReactComponent };